window.anvil.block('hero-product-details', el => {
    const mainSliderEl = el.querySelector('.js-gallery-main');
    const gallerySliderEl = el.querySelector('.js-gallery-thumbs');
    const sizeBtns = el.querySelectorAll('.js-size-btn');
    const images = el.querySelectorAll('.js-image');
    const buyNowLink = 'https://order.gfs.com/product/';

    // Sizes Button click handling
    if (sizeBtns) {
        sizeBtns.forEach(sizeBtn => {
            sizeBtn.addEventListener('click', e => {
                e.preventDefault();

                let isActive = sizeBtn.classList.contains('active');

                // If it's already active then return
                if(isActive) return;

                const active = el.querySelector('.js-size-btn.active');

                if (active) {
                    active.classList.remove('active', 'style-primary');
                    active.classList.add('style-secondary');
                }

                // Remove current active size and Set clicked active
                sizeBtn.classList.add('active', 'style-primary');
                sizeBtn.classList.remove('style-secondary');

                let index = sizeBtn.dataset.index;
                let packSize = sizeBtn.dataset.size;
                let productCode = sizeBtn.dataset.productCode;

                const buyNowBtn = el.querySelector('.js-buy-now');
                if (buyNowBtn && buyNowBtn.href.startsWith(buyNowLink)) buyNowBtn.href = buyNowLink + productCode;

                if (images) {
                    images.forEach(image => {
                        image.classList.remove('active');

                        if (image.dataset.index == index) image.classList.add('active');
                    });
                }

                // toggle visibility of elements where data-pack-size equals the packSize of clicked item
                const filterableItems = document.querySelectorAll('.js-package-filter');

                if (filterableItems) {
                    filterableItems.forEach(filter => {
                        if (filter.dataset.packSize == packSize) {
                            filter.classList.remove('hidden');
                        } else {
                            filter.classList.add('hidden');
                        }
                    });
                }
            });
        });

        sizeBtns[0].click();
    }

    if (mainSliderEl) {
        let galleryThumbs, galleryMain, thumbs;

        if (gallerySliderEl) {
            galleryThumbs = new Swiper(gallerySliderEl, {
                slidesPerView: 5,
                slideToClickedSlide: true,
                watchOverflow: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                direction: 'vertical',
                spaceBetween: 10
            });

            thumbs = {
                swiper: galleryThumbs
            };
        }

        galleryMain = new Swiper(mainSliderEl, {
            autoHeight: true,
            slidesPerView: 1,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            navigation: {
                nextEl: el.querySelector('.js-next'),
                prevEl: el.querySelector('.js-prev'),
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            thumbs
        });

        if (galleryMain && galleryThumbs) {
            galleryMain.on('slideChangeTransitionStart', function () {
                galleryThumbs.slideTo(galleryMain.activeIndex);
            });

            galleryThumbs.on('transitionStart', function () {
                galleryMain.slideTo(galleryThumbs.activeIndex);
            });
        }

        // Image zoom
        galleryMain && galleryMain.slides.forEach(slide => {
            const imageContainer = slide.querySelector('.magnify');

            if (!imageContainer) return;

            const zoomImage = slide.querySelector('.img');
            let scale = 1;

            // Initial zoom on hover
            imageContainer.addEventListener('mouseenter', () => {
                scale = 1;
                zoomImage.style.transform = 'scale(1.5)';
            });

            // Reset the zoom on mouse leave
            imageContainer.addEventListener('mouseleave', () => {
                scale = 1;
                zoomImage.style.transform = 'scale(1)';
            });

            // Change image position on mouse movement
            imageContainer.addEventListener('mousemove', e => {
                const { left, top, width, height } = imageContainer.getBoundingClientRect();
                const x = e.clientX - left;
                const y = e.clientY - top;

                const xPercent = (x / width) * 100;
                const yPercent = (y / height) * 100;

                zoomImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
            });

            // Zoom in and out based on scroll wheel
            imageContainer.addEventListener('wheel', e => {
                e.preventDefault();

                scale += e.deltaY * -0.005;
                scale = Math.min(Math.max(1, scale), 2.5);

                zoomImage.style.transform = `scale(${scale})`;
            });
        });
    }
});
